import { SigninCard } from '@ordo/ui/signin-card'

export function Login() {
  return <SigninCard appKey="boombox" loginHref="/api/auth/login" />
}
